// @flow
import React from 'react'
import classnames from 'classnames'

import Button from '../button/Button'

import type { ButtonT } from '../button/Button.type'

const AlertButton = ({ children, className, type = 'button', text, onClick = () => {}, disabled = false, ...rest }: ButtonT) => (
  <Button
    {...rest}
    className={classnames('alert', className)}
    type={type}
    text={text}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </Button>
)

export default AlertButton
